/**
 * Test IDs for QA automation.
 */
export const testIds = {
  driverShiftAssignmentsListAssignShift: "driver-shift-assignments-list-assign-shift",
} as const;
